import { Link, Stack, Text } from '@fluentui/react'
import { differenceInYears } from 'date-fns/fp'
import { flow } from 'lodash/fp'
import React, { memo } from 'react'
import { IClient } from '../../api/client.types'
import { parseDateISOStringInLocalTimezone } from '../../shared'
import { getMostRecentLoginDetails } from '../../shared/client'
import { ClientMenuContainer, IClientMenuContainerProps } from '.'

interface ILegalEntityNameCellProps {
  client: IClient
  onNameClicked: (client: IClient) => void
  menu?: React.FC<IClientMenuContainerProps> | null
}

export const LegalEntityNameCell: React.FC<ILegalEntityNameCellProps> = memo(
  ({ client, onNameClicked, menu }) => {
    const Menu = menu || ClientMenuContainer
    const wealthscapeId = getMostRecentLoginDetails(
      client?.loginDetails
    )?.WealthscapeID
    const {
      LegalEntityName,
      srcClientNumber,
      legalEntityType,
      dateofBirth,
      Account
    } = client
    const onClientOnlineLinkClicked = (
      event: React.MouseEvent<
        HTMLAnchorElement | HTMLElement | HTMLButtonElement,
        MouseEvent
      >
    ) => {
      onNameClicked(client)
      event.preventDefault()
    }

    let legalEntityTypeDisplay = legalEntityType
    switch (legalEntityType) {
      case 'P': {
        legalEntityTypeDisplay = 'Individual'
        break
      }
      case 'B': {
        legalEntityTypeDisplay = 'Organization'
        break
      }
    }

    const additionalInfo = [
      legalEntityTypeDisplay,
      Account && `${Account.length} acct${Account.length > 1 ? 's' : ''}`,
      srcClientNumber,
      dateofBirth &&
        `${Math.abs(
          flow(
            parseDateISOStringInLocalTimezone,
            differenceInYears(Date.now())
          )(dateofBirth)
        )} yo`
    ].filter((x) => x)

    return (
      <Stack
        horizontal={true}
        tokens={{ childrenGap: 5 }}
        styles={{ root: { alignItems: 'center', minWidth: 0 } }}
      >
        {menu !== null && <Menu client={client} />}
        <Stack styles={{ root: { minWidth: 0 } }}>
          <Stack
            horizontal={true}
            styles={{ root: { minWidth: 0 } }}
            tokens={{ childrenGap: 3 }}
          >
            {wealthscapeId ? (
              <Link
                styles={{ root: { minWidth: 0 } }}
                onClick={onClientOnlineLinkClicked}
                href={`/clients/${wealthscapeId}`}
                target="_blank"
              >
                <Text nowrap={true} block={true} title={LegalEntityName}>
                  {LegalEntityName}
                </Text>
              </Link>
            ) : (
              <Text nowrap={true} block={true} title={LegalEntityName}>
                {LegalEntityName}
              </Text>
            )}
          </Stack>
          <Stack
            horizontal={true}
            styles={{ root: { minWidth: 0 } }}
            tokens={{ childrenGap: 3 }}
          >
            {additionalInfo.length > 0 &&
              additionalInfo
                .map((info, i) => (
                  <Text key={i} variant="small" nowrap={true}>
                    {info}
                  </Text>
                ))
                .reduce((a, x) =>
                  a === null ? (
                    x
                  ) : (
                    <>
                      {a}
                      <Text variant="small">|</Text>
                      {x}
                    </>
                  )
                )}
          </Stack>
        </Stack>
      </Stack>
    )
  }
)
